<div class="card{{getCardWrapperClass() ? ' '+getCardWrapperClass() : ''}}">
  <div class="card-header">
    {{ getLabel() }}
    <a class="float-end" *ngIf="getLink()" [routerLink]="[getLink().link]">{{getLink().label}}</a>
  </div>
  <div class="card-body">
    <ng-container #fieldComponent></ng-container>
  </div>
  <button  class="btn btn-outline-primary mt-0 mx-4 mb-4" type="button" *ngIf="getButton()" (click)="getButton().onClick()">{{getButton().label}}</button>
</div>

